import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {SquadAgentContainerModel} from "../../../../../../../models/aggregates/alg/cc/squad";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class SquadAgentService extends BaseApiTemplateService<SquadAgentContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'squad-agent-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'squad-agent-links';
    this.httpClient = http;
  }
}
